import Personvelger from './Personvelger';

globalThis.PersonvelgerComponents = {
  Personvelger,
};
